<div class="card m-0">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h6 class="m-0 fw-bold">Add Another Resident</h6>
      </div>
      <div class="col-auto">
        <button type="button" class="btn" (click)="modal.hide()">
          <i class="bx bx-x font-size-24"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body bg-light">
    <form #form="ngForm" class="row" autocomplete="off">
      <div class="col-12">
        <div class="alert alert-primary d-flex" role="alert">
          <div>
            <p class="m-0">{{ info }}</p>
          </div>
        </div>
      </div>
      <ng-container [ngSwitch]="step">
        <ng-container *ngSwitchCase="0">
          <div class="col-12 mb-2" *ngIf="error">
            <div class="alert alert-danger d-flex" role="alert">
              <div>
                <p class="m-0">{{ error }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 mb-2">
            <label class="w-100" for="code">
              Enter your code<span class="text-danger">*</span>
              <input
                type="text"
                class="form-control"
                autocomplete="off"
                id="code"
                name="code"
                #code="ngModel"
                [(ngModel)]="model.code"
                required
                [ngClass]="{
                  'is-invalid': submitted && code.invalid,
                }"
              />
            </label>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="1">
          <div class="col-12 mb-2">
            <button type="button" class="btn btn-light" (click)="onModal()">Wrong Resident?</button>
          </div>

          <div class="col-12 mb-2">
            <label class="w-100" for="relationshipId">
              Relation to Resident<span class="text-danger">*</span>
              <select
                class="form-select"
                autocomplete="new-input"
                #relationshipId="ngModel"
                id="relationshipId"
                name="relationshipId"
                [(ngModel)]="model.relationshipId"
                [ngClass]="{
                  'is-invalid': submitted && relationshipId.invalid,
                }"
                required
              >
                <option [value]="null">Select...</option>
                <option *ngFor="let relation of relationships$ | async" [value]="relation.id">
                  {{ relation.name }}
                </option>
              </select>
            </label>
          </div>
        </ng-container>
      </ng-container>
    </form>
  </div>

  <div class="card-footer bg-white">
    <div class="row g-3 align-items-center justify-content-end">
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="modal.hide()">Cancel</button>
      </div>
      <div class="col-auto">
        <button *ngIf="step === 0" type="button" class="btn btn-primary" (click)="onCode()">
          Next
        </button>
        <button *ngIf="step === 1" type="button" class="btn btn-primary" (click)="ngSubmit()">
          Finish
        </button>
      </div>
    </div>
  </div>
</div>
